import { getImageWidth } from './getImageWidth';
import { remToPx } from './remToPx';
import { getSizeForBreakpoint } from './getSizeForBreakpoint';
export const getImageWidths = (breakpoints, sizes) => Array.from(breakpoints.reduce((all, breakpoint, i) => {
    all.add(getImageWidth(getSizeForBreakpoint(sizes, i), remToPx(breakpoint), 1));
    all.add(getImageWidth(getSizeForBreakpoint(sizes, i), remToPx(breakpoint), 2));
    return all;
}, new Set())).sort();
//# sourceMappingURL=getImageWidths.js.map